 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import HALFTITLE from '@/components/halftitle'
 import TITLEPAGE from '@/components/titlepage'
 import COPYRIGHT from '@/components/copyright'
 import FM from '@/components/fm'
 import DEDICATION from '@/components/dedication'
 import TOC from '@/components/toc'
 import ACKNOWLEDGEMENTS from '@/components/acknowledgements'
 import EPHESIANS from '@/components/ephesians'
 import INTRODUCTION from '@/components/introduction'
 import CHAPTER001 from '@/components/chapter001'
 import CHAPTER002 from '@/components/chapter002'
 import CHAPTER003 from '@/components/chapter003'
 import CHAPTER003A from '@/components/chapter003a'
 import CHAPTER004 from '@/components/chapter004'
 import CHAPTER004A from '@/components/chapter004a'
 import CHAPTER005 from '@/components/chapter005'
 import CHAPTER005A from '@/components/chapter005a'
 import CHAPTER006 from '@/components/chapter006'
 import CHAPTER007 from '@/components/chapter007'
 import CHAPTER008 from '@/components/chapter008'
 import LOVE_2 from '@/components/love_2'
 import A_PRAYER from '@/components/a_prayer'
 import NOTES from '@/components/notes'
 import ABO_AUT from '@/components/abo_aut'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/acknowledgements",
 			"name" : "acknowledgements",
 			"component" : ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/ephesians",
 			"name" : "ephesians",
 			"component" : EPHESIANS
 		},
 		{
 			"path" : "/introduction",
 			"name" : "introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/chapter001",
 			"name" : "chapter001",
 			"component" : CHAPTER001
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js